import { Ioption } from 'tradevan-ui/type';
import { EnumDownloadType, EnumExportItemList } from 'view/Layout/enum';
import { IexportItemList } from 'view/Layout/type';

/** 退貨單下載 報表下載下拉選單  */
export const getDownloadOptions = (
  exportItemList: IexportItemList,
): Ioption[] => {
  const options = [
    {
      value: EnumDownloadType.報表下載,
      label: '報表下載',
      show: exportItemList[EnumExportItemList.rptDefault],
    },
    {
      value: EnumDownloadType.退貨通知報表下載,
      label: '退貨通知報表下載',
      show: exportItemList[EnumExportItemList.rptReturnNote],
    },
    {
      value: EnumDownloadType.退貨驗收報表下載,
      label: '退貨驗收報表下載',
      show: exportItemList[EnumExportItemList.rptReturn],
    },
    {
      value: EnumDownloadType.批次預覽,
      label: '批次預覽',
      show: exportItemList[EnumExportItemList.previewDefault],
    },
    {
      value: EnumDownloadType.退貨通知批次預覽,
      label: '退貨通知批次預覽',
      show: exportItemList[EnumExportItemList.previewReturnNote],
    },
    {
      value: EnumDownloadType.退貨驗收批次預覽,
      label: '退貨驗收批次預覽',
      show: exportItemList[EnumExportItemList.previewReturn],
    },

    {
      value: EnumDownloadType.TXT檔下載,
      label: 'TXT檔下載',
      show: exportItemList[EnumExportItemList.flatfileTxt],
    },
    {
      value: EnumDownloadType.CSV檔下載,
      label: 'CSV檔案下載',
      show: exportItemList[EnumExportItemList.flatfileCsv],
    },
  ];

  return options.filter((v) => v.show);
};

export default getDownloadOptions;
